module.exports = __webpack_public_path__ + "3c046b5e033e65c8ae08130977475bf7.svg";